module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_album-30c35323de1eb66f8310c0a4fe8647b0.png";